import { useRef, useState } from "react";
import ReviewCandidatesPopover from "./ReviewCandidatesPopover";
import { hasNoMatch, needsReview } from "../utils";
import type { BulkMatchRow, MatchCandidate } from "../types";

type MatchRowActionProps = {
  row: BulkMatchRow;
  onCandidateSelected: (rowId: string, candidate: MatchCandidate) => void;
};

const MatchRowAction = ({ row, onCandidateSelected }: MatchRowActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const hasSuggestions = (row.candidates?.length ?? 0) > 1;

  if (hasNoMatch(row) || !hasSuggestions) {
    return <div className="tw-h-full" />;
  }

  const triggerLabel = row.is_reviewed ? "Reviewed" : needsReview(row) ? "Review and Choose" : "Change";

  return (
    <div className="tw-relative">
      <button ref={triggerRef} type="button" onClick={() => setIsOpen((open) => !open)} className="tw-flex tw-items-center tw-gap-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-sm tw-text-gray-900 hover:tw-text-primary-purple-600">
        {triggerLabel}
        <span className="material-symbols-outlined tw-text-base tw-leading-none">expand_more</span>
      </button>
      {isOpen && (
        <ReviewCandidatesPopover
          anchorRef={triggerRef}
          candidates={row.candidates}
          selectedCompanyId={row.matched_company?.company_id}
          onSelect={(candidate) => {
            onCandidateSelected(row.row_id, candidate);
            setIsOpen(false);
          }}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default MatchRowAction;
